import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';

import { DebounceClickDirectiveModule } from 'src/app/directives/debounce-click/debounce-click-directive.module';
import { SignaturePadModal } from './signature-pad.modal';

@NgModule({
  declarations: [SignaturePadModal],
  imports: [
    CommonModule,
    IonicModule,
    TranslocoModule,
    DebounceClickDirectiveModule
  ],
  exports: [SignaturePadModal]
})
export class SignaturePadModalModule {}
